import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';

import { SET_USER_INFO, SET_USER_BALANCE, SET_BOOKING } from '../mutations.js';

export default {
  state: {
    info: {},
    booking: [],
    balanceLoad: false,
    actualLanguageChannels: []
  },

  mutations: {
    [SET_USER_INFO]: (state, { ...info }) => {
      state.info = info;
    },

    [SET_BOOKING]: (state, booking) => {
      state.booking = [...state.booking, ...booking];
    },

    [SET_USER_BALANCE]: (state, { balance, time, coef, canOut }) => {
      state.info.balance = balance;
      state.info.workedMins = time;
      state.info.coef = coef;
      state.info.canOut = canOut;
      state.balanceLoad = true;
    }
  },

  actions: {
    getUserInfo: async ({ commit, dispatch }) => {
      const res = await apiRequest('user', 'GET', null, true);

      const {
        id,
        email,
        phone,
        avatar,
        name,
        last_name,
        t_api_key,
        t_chat_id,
        settings,
        booking,
        curator,
        timezone,
        calendar
      } = res.success;

      commit(SET_USER_INFO, {
        id,
        email,
        phone,
        avatar,
        name,
        telegramApiKey: t_api_key,
        telegramChatId: t_chat_id,
        lastName: last_name,
        settings,
        curator: !!curator,
        timezone,
        calendar
      });

      commit(
        SET_BOOKING,
        booking.map(({ id, start, level_id, language_id }) => ({
          id,
          start,
          levelId: level_id,
          languageId: language_id
        }))
      );

      await dispatch('getUserBalance');
    },

    getUserBalance: async ({ commit }) => {
      const res = await apiRequest('balance/get', 'GET', null, true);

      if (res.error) {
        throw res.error;
      }

      commit(SET_USER_BALANCE, {
        balance: Number(res.success.amount.toFixed(2)),
        time: res.success.minutes,
        coef: res.success.coef,
        canOut: res.success.can_out
      });
    },

    createWithdraw: async ({ commit }) => {
      try {
        const res = await apiRequest('withdraw/create', 'POST', null, true);

        if (res.error) {
          notify({ text: res.error });
        }

        commit(SET_USER_BALANCE, { balance: 0, time: 0 });
      } catch (error) {
        console.log('withdraw/create ERROR');
      }
    }
  }
};
